import * as THREE from "three";
import { createLabel } from "../../../TOOLS/LabelFactory";

export class Office {
  constructor(store, parent, label, id, district) {
    this.store = store;
    this.parent = parent;
    this.label = label;
    this.id = id;
    this.district = district;
    this.group = new THREE.Group();
    this.parent.add(this.group);
    this.colleagueGroup = new THREE.Group();
    this.colleagueGroup.position.y = 1;
    this.group.add(this.colleagueGroup);
    this.meshGroup = new THREE.Group();
    this.group.add(this.meshGroup);
    this.model = null;
    this.nameLabel = null;
    this.store.entities.offices[this.id] = this;
    this.colleagues = [];
    this.targetY = 0;
    this.load();
  }

async load() {
    this.model = this.store.assetManager.getModel("office");
    this.model.scale.setScalar(0.3);
    this.model.position.set(0, 0.7, 0);
    this.model.traverse((child) => {
      if (child.isMesh) {
        child.castShadow = true;
        child.receiveShadow = true;
      }
    });
    this.model.userData.type = 'office';
    this.model.userData.instance = this;
    //CLICKABLES TÖMBBŐL NEM TÖRÖLHETŐ
    this.model.userData.baseObject = true;
    const box = new THREE.Box3().setFromObject(this.model);
    const size = new THREE.Vector3();
    box.getSize(size);
    this.nameLabel = createLabel(this.label, {fontSize: this.store.config.isSmall ? 72 : 72, position: new THREE.Vector3(0, size.y + 2, 0)});
    this.model.add(this.nameLabel);
    this.store.input.clickables.push(this.model);
    this.meshGroup.add(this.model);
    
  }

    update() {
        if (!this.model) return;
        const isSelected = this.store.level.levelName === "OFFICE" &&  this.store.level.selectedOffice === this;
        if (this.store.level.levelName === "CITIES") {
            this.targetY = 9;
        }else if (this.store.level.levelName === "CITYUSER") {
            this.targetY = 1;
        }else if (this.store.colleaguesByOfficeId !== undefined) {
            const count = this.store.colleaguesByOfficeId.length;
            let mobilePadding = this.store.config.isSmall ? 2 : 0
            this.targetY = isSelected ? (2.2 + (count - 10) * 0.1) + mobilePadding : 0;
        }

        this.group.position.y = THREE.MathUtils.lerp(this.group.position.y, this.targetY, 0.08);
        if (this.store.level.levelName === "CITIES") {
            if (this.group.position.y > 8.8) {
                this.model.visible = false;
                this.nameLabel.visible = false;
                this.colleagueGroup.visible = false;
            }
        } else {
            this.model.visible = true;
            this.nameLabel.visible = true;
            this.colleagueGroup.visible = true;
        }
        this.group.updateWorldMatrix(true, true);
        this.colleagues.forEach(colleague => {colleague.update();});
    }



  getWorldPosition() { return this.group.getWorldPosition(new THREE.Vector3());}

  dispose() {this.parent.remove(this.group);}
}